// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ymBc","col":"styles_col__3kurU"};